export default {
  paymentTypeMap: {
    0: '扫码支付',
    1: '现金支付',
    2: '会员支付',
    3: '微信支付',
    4: '支付宝支付',
    5: '组合支付'
  },
  productTypeList: [
    { label: '农户贷', value: 1 },
    { label: '企业贷', value: 2 }
  ],
  productTypeMap: {
    1: '农户贷',
    2: '企业贷'
  },
  applicationStateList: [
    { label: '待审批', value: 0 },
    { label: '已通过', value: 1 },
    { label: '已拒绝', value: 2 }
  ],
  applicationStateMap: {
    0: '待审批',
    1: '已通过',
    2: '已拒绝'
  },
  applicationTagMap: {
    0: '',
    1: 'success',
    2: 'warning'
  }
};
